var popupSelect = function(selectID,config){
  this.selectID = selectID;
  this.select = document.getElementById(selectID);
  this.config = config;
  this.load();

};

popupSelect.prototype.load = function(){
  this.layout();

};

popupSelect.prototype.remove = function(){
  this.popup.remove();
}

popupSelect.prototype.layout = function(){
  this.popup = document.createElement("div");
  this.popup.classList.add("popupSelect_popup");
  this.popup.setAttribute("id",this.selectID+"_popup");

  document.body.append(this.popup);

  var options = this.select.options;
  var optionList = document.createElement("ul");
  for(let o of options){

    var option = document.createElement("li");
    var optionText = o.innerText;
    if(this.config.optionPrepend){
        optionText = this.config.optionPrepend + optionText;
    }

    if(this.config.optionAppend){
        optionText += this.config.optionAppend;
    }
    option.innerHTML = optionText;

    option.setAttribute("data-value",o.value);
    option.addEventListener("click",(e)=>{
      var value = e.currentTarget.getAttribute("data-value");
      var label = e.currentTarget.innerHTML;

      this.updateValue(value);
      this.hideOptions();
      this.popup.getElementsByClassName("selected").length > 0 ? this.popup.getElementsByClassName("selected")[0].classList.remove("selected") : false;
      e.currentTarget.classList.add("selected");

      if(this.config.onChange){
        this.config.onChange();
      }

    });
    optionList.append(option);


  }

  if(this.config.title){
    var header = document.createElement("div");
    header.classList.add("selectHeader");
    header.innerHTML = this.config.title;
    optionList.prepend(header);
  }


  this.popup.append(optionList);



  optionList.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget){
      return;
    }

    this.hideOptions();
  });

  this.popup.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget){
      return;
    }

    this.hideOptions();
  });

  this.selectToggle = document.createElement("div");
  this.selectToggle.classList.add("popupSelect_toggle");
  this.selectToggle.classList.add(this.selectID+"_toggle");
  this.selectToggle.addEventListener("click",(e)=>{

    this.showOptions();
  });

  this.select.parentNode.insertBefore(this.selectToggle,this.select);
  this.select.style.display = "none";

  this.select.addEventListener("click",(e)=>{
    this.showOptions();
  })

  this.updateLabel();

  if(optionList.scrollHeight > window.innerHeight){
    optionList.style.paddingTop = "40vh";
    optionList.style.paddingBottom = "40vh";


    optionList.addEventListener("scroll",(e)=>{
      this.scrollPerspective(e.currentTarget);
    });

    this.arrowDown = document.createElement("div");
    this.arrowDown.classList.add("arrowDown");
    this.arrowDown.innerHTML = "&#9660;";
    this.popup.append(this.arrowDown);

    this.arrowDown.addEventListener("click",(e)=>{
      var ul = this.popup.querySelector("ul");
      var newScroll = ul.scrollTop + (ul.offsetHeight*.6);
      ul.scrollTo({top:newScroll,behavior:"smooth"});
    });

    this.arrowUp = document.createElement("div");
    this.arrowUp.classList.add("arrowUp");
    this.arrowUp.innerHTML = "&#9650;";
    this.popup.append(this.arrowUp);

    this.arrowUp.addEventListener("click",(e)=>{
      var ul = this.popup.querySelector("ul");
      var newScroll = ul.scrollTop - (ul.offsetHeight*.6);
      ul.scrollTo({top:newScroll,behavior:"smooth"});
    });

    optionList.addEventListener("scroll",(e)=>{
      this.scrollArrowDown(e.currentTarget);
      this.scrollArrowUp(e.currentTarget);
    });
  }




};

popupSelect.prototype.showOptions = function(){
  this.popup.classList.add("show");
  document.body.style.overflowY = "hidden";
  if(this.popup.querySelector("ul").scrollHeight > window.innerHeight){

    setTimeout(()=>{

      this.scrollPerspective(this.popup.querySelector("ul"));

      setTimeout(()=>{
        var selectedOption = this.popup.querySelector("li.selected");
        if(selectedOption){
            var optionOffset = selectedOption.getBoundingClientRect();
            var ul = this.popup.querySelector("ul");

            var newScroll = (optionOffset.top + ul.scrollTop) - (window.innerHeight*0.4);
            ul.scrollTo({top:newScroll,behavior:"smooth"});
        }
      },100);


    },450);
  }
};

popupSelect.prototype.scrollArrowDown = function(el){
  var bottomScrollRemaining = el.scrollHeight-el.offsetHeight-el.scrollTop;
  if(bottomScrollRemaining > el.offsetHeight *.4){
    this.arrowDown.style.opacity = 0.6;
  }
  else{
    this.arrowDown.style.opacity = 0;
  }
}

popupSelect.prototype.scrollArrowUp = function(el){

  if(el.scrollTop > el.offsetHeight *.5){
    this.arrowUp.style.opacity = 0.6;
  }
  else{
    this.arrowUp.style.opacity = 0;
  }
}

popupSelect.prototype.hideOptions = function(){
  this.popup.classList.remove("show");
  document.body.style.overflowY = "auto";

};

popupSelect.prototype.scrollPerspective = function(element){



  var options = element.querySelectorAll("li");
  var liHeight = options[0].offsetHeight;
  var optionsHeight = element.offsetHeight;
  var topThreshold = ((liHeight*2)+liHeight/2);
  var bottomThreshold = element.offsetHeight - topThreshold;

  for(let o of options){
    var oBounds = o.getBoundingClientRect();
    var rotateX = oBounds.top > bottomThreshold ? oBounds.top - bottomThreshold : 0;
    var transformOrigin = oBounds.top > bottomThreshold ? "top center" : "bottom center";
    rotateX = oBounds.top < topThreshold ? topThreshold - oBounds.top : rotateX;
    rotateX = rotateX > 90 ? 90 : rotateX;

    //var opacity =oBounds.top > bottomThreshold ? 1-((oBounds.top - bottomThreshold)/oBounds.top) : 1;
    var opacity =oBounds.top > bottomThreshold ? (optionsHeight-oBounds.top)/topThreshold : 1;
    opacity = oBounds.top < topThreshold ? 1-(topThreshold-oBounds.top)/topThreshold : opacity;

    var scale = opacity*2.4;
    scale = scale > 1 ? 1 : scale;
    scale = scale < 0.6 ? 0.6 : scale;

    o.style.transform = "rotateX("+rotateX+"deg) scale("+scale+")";
    o.style.transformOrigin = transformOrigin;
    o.style.opacity = opacity;





  }

}


popupSelect.prototype.updateValue= function(value){
  var newSelectIndex = 0;
  var options = this.select.options;

  for(let o of options){

    if(o.value == value){
      break;
    }
    newSelectIndex++;
  }
  this.select.selectedIndex = newSelectIndex;
  this.updateLabel();
}


popupSelect.prototype.updateLabel = function(value){
  var labelValue = this.select.options[this.select.selectedIndex].innerHTML

  this.selectToggle.innerHTML = labelValue;
  this.popup.querySelector("li.selected") && this.popup.querySelector("li.selected").classList.remove("selected");
  this.popup.querySelector("li[data-value='"+this.select.options[this.select.selectedIndex].value+"']") && this.popup.querySelector("li[data-value='"+this.select.options[this.select.selectedIndex].value+"']").classList.add("selected");
}
